import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SharedModule } from '../../shared';
import { ModalModule } from 'ngx-bootstrap/modal';
import { EffectsModule } from '@ngrx/effects';
import { SetupEffects } from './setup-store/setup.effects';
import { InternalSharedModule } from '../shared';
import { SetupMainComponent } from './layouts';
import {
  ReviewAnticipatedExpendituresComponent,
  SetupComponentAgingComponent
} from './components';
import { SetupFiscalYearComponent } from './pages';
import { services } from './shared/services';
import { setupRoutes } from './setup.routing';
const PROVIDERS = [
  ...services
];

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([SetupEffects]),
    FormsModule,
    InternalSharedModule,
    ModalModule,
    ReactiveFormsModule,
    RouterModule.forChild(setupRoutes),
    SharedModule,
  ],
  providers: [
    PROVIDERS
  ],
  declarations: [
    /* Layouts */
    SetupMainComponent,

    /* Pages */
    SetupFiscalYearComponent,

    /* Components */
    ReviewAnticipatedExpendituresComponent,
    SetupComponentAgingComponent
  ],
  exports: [
    SetupMainComponent
  ]
})
export class SetupModule { }
